import { type CryptoPaymentData } from '@app/client/common/structs/orders/cart';

import {
    ACTION_RESET_CRYPTO_STORE,
    type CryptoActionTypes,
    SET_PAYMENT_METHODS,
    SET_PURCHASED_AMOUNT,
} from '../types/crypto';

interface CryptoReducerInterface {
    paymentMethodsData: CryptoPaymentData[];
    salesAmount: {
        amount: number;
        actualAmount: number;
    };
}

const initState: CryptoReducerInterface = {
    paymentMethodsData: [],
    salesAmount: {
        amount: 0,
        actualAmount: 0,
    },
};

export function crypto(state: CryptoReducerInterface = initState, action: CryptoActionTypes): CryptoReducerInterface {
    switch (action.type) {
        case ACTION_RESET_CRYPTO_STORE:
            return initState;

        case SET_PAYMENT_METHODS: {
            return {
                ...state,
                paymentMethodsData: action.payload,
            };
        }
        case SET_PURCHASED_AMOUNT: {
            return {
                ...state,
                salesAmount: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
